import Step10 from './Step10-compose';

export default Step10;
